<div class="main-view space-y-2 md:space-y-4">
  @if (loading) {
    <div class="rounded-3xl border border-white-light/80 bg-white p-6 shadow-sm dark:border-[#191e3a] dark:bg-[#0e1726]">
      <p class="text-sm text-gray-500 dark:text-white-dark">Loading template…</p>
    </div>
  } @else if (loadError) {
    <div class="rounded-3xl border border-white-light/80 bg-white p-6 shadow-sm dark:border-[#191e3a] dark:bg-[#0e1726]">
      <p class="text-sm text-danger">{{ loadError }}</p>
      <button type="button" class="btn btn-sm mt-3 rounded-full px-3" (click)="loadTemplate()">
        Retry
      </button>
    </div>
  } @else if (templateData) {
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="grid grid-cols-1 gap-4 xl:grid-cols-12">
        <!-- Editor -->
        <div class="xl:col-span-7 rounded-3xl border border-white-light/80 bg-white shadow-sm dark:border-[#191e3a] dark:bg-[#0e1726]">
          <div class="px-6 py-4">
            <h1 class="text-base font-semibold text-black dark:text-white">Custom Email</h1>

            <div class="mt-5 flex items-center justify-between">
              <h6 class="text-sm font-semibold text-[#112030] dark:text-[#ffffffcc]">
                {{ templateData.template_name }}
              </h6>
              <input type="hidden" formControlName="is_active" />
              @if (P.EMAIL_TEMPLATE_UPDATE | hasPermission) {
              <button
                type="button"
                class="email-toggle"
                [class.is-active]="form.controls.is_active.value"
                (click)="toggleStatusInForm()"
              >
                <span class="email-toggle__label">
                  {{ form.controls.is_active.value ? 'Active' : 'Inactive' }}
                </span>
                <span class="email-toggle__knob"></span>
              </button>
              } @else {
              <span class="text-sm font-semibold text-gray-600 dark:text-white-dark">
                {{ form.controls.is_active.value ? 'Active' : 'Inactive' }}
              </span>
              }
            </div>

            @if (saveError) {
              <p class="mt-3 text-sm text-danger">{{ saveError }}</p>
            }

            <div class="grid gap-6 pt-4">
              <div>
                <label class="field-label" for="subject">Subject</label>
                <input
                  id="subject"
                  type="text"
                  class="form-input"
                  formControlName="subject"
                  placeholder="Enter Subject"
                  [readonly]="!canEditTemplate"
                />
              </div>

              <div>
                <p class="field-label" id="keywords-label">Keywords</p>
                <p class="field-hint">Drag into description or click to insert</p>
                @if (macroKeys.length) {
                  <div class="keyword-pill-row" aria-labelledby="keywords-label">
                    @for (key of macroKeys; track key) {
                      <button
                        type="button"
                        class="keyword-pill"
                        draggable="true"
                        (dragstart)="onKeywordDragStart($event, key)"
                        (click)="insertMacroByKey(key)"
                      >
                        {{ '{' }}{{ '{' }}{{ key }}{{ '}' }}{{ '}' }}
                      </button>
                    }
                  </div>
                } @else {
                  <p class="text-xs text-gray-500 dark:text-white-dark">No keywords defined for this template.</p>
                }
              </div>

              <div>
                <label class="field-label" for="description">Description</label>
                <p class="field-hint">Body content only — header and footer are added automatically on save.</p>
                <div
                  class="NgxEditor__Wrapper email-editor-wrap"
                  [class.is-drag-over]="editorDragActive && canEditTemplate"
                  (dragover)="canEditTemplate && onEditorDragOver($event)"
                  (dragleave)="canEditTemplate && onEditorDragLeave($event)"
                  (drop)="canEditTemplate && onEditorDrop($event)"
                >
                  @if (canEditTemplate) {
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" />
                  }
                  <ngx-editor
                    [editor]="editor"
                    [spellcheck]="true"
                    class="email-editor"
                    placeholder="Enter Text"
                    formControlName="html_content"
                    [disabled]="!canEditTemplate"
                  />
                </div>
              </div>
            </div>

            @if (testMailError) {
              <p class="mt-3 text-sm text-danger">{{ testMailError }}</p>
            }

            <div class="flex flex-wrap justify-end gap-2 pt-6">
              <button
                type="button"
                class="btn rounded-full border border-gray-200 bg-white px-6 dark:border-[#191e3a] dark:bg-[#0e1726]"
                (click)="backToList()"
                [disabled]="saving || sendingTest"
              >
                Cancel
              </button>
              @if (P.EMAIL_TEMPLATE_UPDATE | hasPermission) {
              <button
                type="button"
                class="btn rounded-full border border-gray-200 bg-white px-6 dark:border-[#191e3a] dark:bg-[#0e1726]"
                (click)="sendTestMail()"
                [disabled]="saving || sendingTest"
              >
                {{ sendingTest ? 'Sending…' : 'Send test email' }}
              </button>
              <button
                type="submit"
                class="btn btn-dark rounded-full px-6"
                [disabled]="saving || sendingTest"
              >
                {{ saving ? 'Updating…' : 'Update' }}
              </button>
              }
            </div>
          </div>
        </div>

        <!-- Preview -->
        <div class="xl:col-span-5">
          <div class="sticky top-4 rounded-3xl border border-white-light/80 bg-white p-4 shadow-sm dark:border-[#191e3a] dark:bg-[#0e1726]">
            <h2 class="mb-3 text-base font-semibold text-black dark:text-white">Email Preview</h2>
            <div class="email-preview-subject">
              <span class="email-preview-subject__label">Subject</span>
              <p class="email-preview-subject__value">{{ previewSubject || '(No subject)' }}</p>
            </div>
            <div class="email-preview-frame">
              <iframe
                #previewFrame
                class="email-preview-iframe"
                title="Email template preview"
                sandbox="allow-same-origin"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </form>
  }
</div>
